import { mergeStyleSets } from "@fluentui/react";

export const getAnswerStyle = () => {
	return mergeStyleSets({
		root: {
			backgroundColor: "white",
			paddding: "10px",
		},
	});
};
